import ATM from './Atm.js';

function Deposit(){
  return (
    <ATM isDeposit={ true }/>
  )
};

export default Deposit;